import { LangSelectProfile } from 'config';
import { language, inputArrow, inputArrowUpside } from 'static/icons/resizable';
import { components, DropdownIndicatorProps } from 'react-select';
import {
  CustomizedLanguageSelector,
  CustomOption,
  CustomControl,
  Icon,
} from 'view/atoms';
import { IconPadded } from 'view/atoms/IconPadded';
import { languageStyleCustom } from './LanguageSelector.styles';

const option = CustomOption('label');
const control = CustomControl(<Icon src={language} alt='location' />);

const LanguageDropdownIndicator = (
  props: DropdownIndicatorProps<LangSelectProfile, false>,
) => (
  <components.DropdownIndicator {...props}>
    <IconPadded
      src={props.selectProps.menuIsOpen ? inputArrowUpside : inputArrow}
    />
  </components.DropdownIndicator>
);

export const ProfileLanguageSelector = () => (
  <CustomizedLanguageSelector
    customDropDownIndicator={LanguageDropdownIndicator}
    customOption={option}
    customControl={control}
    labelSelector={(opt) => (opt as LangSelectProfile).label}
    customStyle={languageStyleCustom}
  />
);
